import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import MyHeader from '../../../shared/EpicHeaderSimplified/myheader.vue';
import { CommonConfig } from '../../../configs/config.common';
import * as T_T from 'cryface';
import { ESearchBarFeatures } from '../../../models/searchbar.features';
import { AxiosPromise } from '../../../utils/axios.promise';
import { Models } from '../../../models/models';

@Component({
    components: {
        MyHeader
    }
})
export default class EpicHeaderThree extends Vue {
    public title: string = 'EpicHeaderThree';
    @Prop({ default: null })
    public data: any;
    // public logo = '/logo.png';
    public configs = new CommonConfig();
    public avatarUri = `${this.configs.rifoDesignAssetsUrl}/rifo_logo.png`;
    public dropdownShow = false;
    public searchText = '';
    public googleResult: any = null;
    public google: any = null;
    public googlePlaceResult: any = null;
    public requestTimeoutId: any = undefined;
    public navFeature: ESearchBarFeatures = ESearchBarFeatures.Buy;
    @Prop({ default: true })
    public shadowed: any;
    @Watch('searchText', { immediate: true, deep: true })
    public async onSearchTextChange(val: any, oldVal: any) {
    }

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public userDropdown = {
        show: false,
        value: '',
    };

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public async onUserChanged(val: any, oldVal: any) {
        this.avatarUri = T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : this.avatarUri;
    }

    public handleSearch() {
        switch (this.navFeature) {
            case ESearchBarFeatures.Buy: {
                const newFilters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
                newFilters.filterSimpleListingTypes = ['For Sale'];
                this.navToMap(newFilters);
                break;
            }
            case ESearchBarFeatures.Rent: {
                const newFilters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
                newFilters.filterSimpleListingTypes = ['For Rent'];
                this.navToMap(newFilters);
                break;
            }
            case ESearchBarFeatures.FindAgents: {
                break;
            }
            case ESearchBarFeatures.HomeService: {
                break;
            }
            case ESearchBarFeatures.PropertyValue: {
                const newFilters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
                this.navToMap(newFilters);
                break;
            }
        }
    }

    public keyboardWatch(event: any) {
        const text = this.searchText;
        clearTimeout(this.requestTimeoutId);
        if (T_T.simpleDetect(text)) {
            this.requestTimeoutId = setTimeout(async () => {
                // get Dropdown Content
                switch (this.navFeature) {
                    case ESearchBarFeatures.Buy: {
                        await this.autoByAddress(text);
                        break;
                    }
                    case ESearchBarFeatures.Rent: {
                        await this.autoByAddress(text);
                        break;
                    }
                    case ESearchBarFeatures.FindAgents: {
                        break;
                    }
                    case ESearchBarFeatures.HomeService: {
                        break;
                    }
                    case ESearchBarFeatures.PropertyValue: {
                        await this.autoByAddress(text);
                        break;
                    }
                }
                // DropDown Show
                this.dropdownShow = true;
            }, 300);
        }
    }

    public async autoByAddress(text: string) {
        if (text.length > 0) {
            this.googleResult = await this.autoCompleteGoogle();
        } else {
            this.googleResult = null;
            this.dropdownShow = false;
        }
    }

    public clearSearchbar() {
        this.searchText = '';
        this.googleResult = null;
        this.dropdownShow = false;
    }

    public async autoCompleteGoogle() {
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/autocomplete?searchtext=${this.searchText}`;
        const fetched = await AxiosPromise.get(google);
        if (fetched.code === 200) {
            return this.autoCompleteDataClean(fetched.data);
        }
        return null;
    }

    public autoCompleteDataClean(dataGotten: any) {
        return T_T.simpleDetect(dataGotten.predictions) ? dataGotten.predictions : [];
    }

    public dropDownOutside() {
        this.dropdownShow = false;
        this.userDropdown.show = false;
    }

    public onDropdownSelected(text: string) {
        this.searchText = text;
        this.dropdownShow = false;
    }

    public async navToMap(filters: Models.IMapListSimpleFilters) {
        if (this.searchText === '') {
            this.searchText = 'Tronto, Ontario';
        }
        if (T_T.simpleDetect(this.searchText)) {
            this.googlePlaceResult = await this.getPlacesGoogle();
        }
        if (this.googlePlaceResult) {
            const geometry = this.googlePlaceResult.geometry;
            if (T_T.simpleDetect(geometry)) {
                if (T_T.simpleDetect(geometry.location)) {
                    this.$store.commit('setCenter', geometry.location);
                }
                const mapFetchingCallback = this.$Message.loading({
                    content: 'Loading, Please Wait...',
                    duration: 0
                });
                await this.$store.dispatch('addressSearch', {
                    googleVal: this.googlePlaceResult,
                    mapFetchingCallback: mapFetchingCallback,
                    filters: filters
                });
                this.$router.push('/map');
            }
        }
        if (!this.googlePlaceResult
            && /^[A-Za-z][0-9]{7}$/.test(this.searchText.trim())
        ) {
            // Format Match MLS number
            const mlsNumber = this.searchText.trim();
            await this.$store.dispatch('MLSNumberSearch', mlsNumber);
            this.$router.push('/map');
        }
    }

    public async getPlacesGoogle() {
        const apiHost = this.configs.analysisService;
        const google = `${apiHost}/google/places?searchtext=${this.searchText}`;
        const fetched = await AxiosPromise.get(google);
        if (fetched.code === 200) {
            if (T_T.simpleDetect(fetched.data.candidates)) {
                if (fetched.data.candidates.length > 0) {
                    return fetched.data.candidates[0];
                }
            }
        }
        return null;
    }

    public handleSignButton() {
        this.$store.commit('bgBlurOn');
    }

    public async logout() {
        const _this: any = this;
        const browserStore = _this.$browserStore;
        browserStore.clearSession();
        this.$store.commit('logout');
    }

    public navToContactUs() {
        window.location.replace(`https://${this.configs.worldWide[0]}/contact-us`);
    }

    public quickSearch(listingType: string) {
        const filters: Models.IMapListSimpleFilters = Models.initMapListSimpleFilters();
        filters.filterSimpleListingTypes = [this.interpratListingType(listingType)];
        // console.log(filters.filterSimpleListingTypes, 'filters.filterSimpleListingTypes ');
        this.navToMap(filters);
    }

    public interpratListingType(listingType: string) {
        if (listingType === 'Buy') {
            return 'For Sale';
        }
        if (listingType === 'Rent') {
            return 'For Rent';
        }
        return listingType;
    }

}
